// POC Bilateral — catálogo de idiomas sincronizado com backend/languages.py (GET /api/languages)
export const LANGUAGES = [
  { code: 'pt', name: 'Português (PT)' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'pl', name: 'Polski' },
  { code: 'ro', name: 'Română' },
  { code: 'uk', name: 'Українська' },
  { code: 'ru', name: 'Русский' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ar', name: 'العربية' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'sv', name: 'Svenska' },
];

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Bandeira do locale por defeito de cada idioma (coerente com o Voice Router: en→en-GB, pt→pt-PT)
export const LANG_FLAGS = {
  pt: 'pt', en: 'gb', es: 'es', fr: 'fr', de: 'de', it: 'it', nl: 'nl', pl: 'pl',
  ro: 'ro', uk: 'ua', ru: 'ru', zh: 'cn', ja: 'jp', ar: 'sa', tr: 'tr', sv: 'se',
};

export const flagClass = (code) => (LANG_FLAGS[code] ? `fi fi-${LANG_FLAGS[code]} rounded-[2px] shrink-0` : '');

// Reconcilia o catálogo local com o backend (fonte de verdade); mantém fallback offline
export async function syncLanguages() {
  try {
    const r = await fetch(`${BACKEND_URL}/api/languages`);
    if (!r.ok) return LANGUAGES;
    const data = await r.json();
    if (Array.isArray(data.languages) && data.languages.length) {
      LANGUAGES.length = 0;
      data.languages.forEach((l) => LANGUAGES.push({ code: l.code, name: l.name }));
    }
  } catch {
    /* offline: mantém catálogo local */
  }
  return LANGUAGES;
}
